import { useReducer, useMemo } from 'react';

type Params = {
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  page: number;
  limit: number;
  search?: string;
  storeType?: string;
  addedByFilter: string;
  statusFilter: string;
  merchantId?: string
  isEdit: boolean; // <-- NEW
};

const getInitialParams = (): Params => {
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const MerchantId = userData?.userId;

  return {
    sortBy: 'createdAt',
    sortOrder: 'asc',
    page: 1,
    limit: 100,
    search: undefined,
    addedByFilter: 'All',
    statusFilter: 'All',
    storeType: undefined,
    merchantId: MerchantId,
    isEdit: false, // <-- NEW
  };
};


type Action =
  | { type: 'SET_SEARCH'; payload: string | undefined }
  | { type: 'SET_PAGE'; payload: number }
  | { type: 'SET_LIMIT'; payload: number }
  | { type: 'SET_SORT'; payload: { sortBy: string; sortOrder: 'asc' | 'desc' } }
  | { type: 'SET_FILTERS'; payload: Partial<Params>; resetPage?: boolean }
  | { type: 'RESET' }
  | { type: 'SET_STORE_TYPE'; payload: string }
  | { type: 'SET_IS_EDIT'; payload: boolean }
| { type: 'SET_MERCHANT_ID'; payload: string | undefined };


function reducer(state: Params, action: Action): Params {
  switch (action.type) {
    case 'SET_SEARCH':
      return { ...state, search: action.payload };
    case 'SET_PAGE':
      return state.page === action.payload ? state : { ...state, page: action.payload };
    case 'SET_LIMIT':
      return { ...state, limit: action.payload };
    case 'SET_SORT':
      return {
        ...state,
        sortBy: action.payload.sortBy,
        sortOrder: action.payload.sortOrder,
      };
    case 'SET_FILTERS':
      return {
        ...state,
        ...Object.fromEntries(
          Object.entries(action.payload).map(([key, val]) => [key, val === '' ? undefined : val])
        ),
      };
    case 'SET_STORE_TYPE':
      return {
        ...state,
        storeType: action.payload || undefined,
      };
    case 'SET_IS_EDIT':
      return { ...state, isEdit: action.payload };
      case 'SET_MERCHANT_ID':
  return { ...state, merchantId: action.payload };

    case 'RESET':
      return getInitialParams();
    default:
      return state;
  }
}


export function useStoreManagementParams() {
  const [params, dispatch] = useReducer(reducer, getInitialParams());

  const stableParams = useMemo(() => params, [
    params.sortBy,
    params.sortOrder,
    params.page,
    params.limit,
    params.search,
    params.addedByFilter,
    params.statusFilter,
    params.storeType,
    params.merchantId,
    params.isEdit
  ]);

  return { params: stableParams, dispatch };
}
